import { Donors } from "@/types/models/Donors";
import { routes } from "@/services/donors.service";
import { fetcher } from "@/lib/apiFetch";
import useSWR, { preload } from "swr";

import { useCallback, useMemo } from "react";
import { fetcherV2 } from "@/services/api";

export function usePreloadDonor() {
  const preloadDonor = useCallback((donorId: number) => {
    preload([routes.get(donorId), {}], fetcherV2);
  }, []);

  return { preloadDonor };
}

export function useDonor(donorId: string | undefined) {
  const { data, error, mutate } = useSWR(
    () => (donorId ? [routes.get(donorId), {}] : undefined),
    fetcherV2<Donors>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    donor: data,
    refresh: mutate,
    isLoading: !error && !data,
    isError: error,
  };
}
